module.exports = __webpack_public_path__ + "static/media/career-founder.78e9a8e1.jpg";